import React, { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Password } from "primereact/password";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import api from "../api";


const Login = () => {

    const navigate = useNavigate();
    const toast = useRef(null);

    const [loading, setLoading] = useState(false);
    const currentDate1 = new Date();
    const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;

    const formik = useFormik({
      initialValues: {
        userid: "",
        password: "",
      },
      validationSchema: Yup.object({
        userid: Yup.string().required("User Name is required"),
        password: Yup.string().required("Password is required"),
      }),
  
      onSubmit: async (values) => {
        try {
          setLoading(true);
          const additionalData = {
            synceddatetime : formattedCurrentDate,
            FormCode : "201",
            ApiKey : "kavin",
            AppTypeNo : "3",
            AppVersion : "1.0.0",
            data_source : "W"
          };
         const response = await api.login(values.userid, values.password, additionalData);
          if (response && response.status === '1') {
            const { fld_role_name,  } = response.loged_in_details[0];
            sessionStorage.setItem('RoleName', fld_role_name);

          navigate("/main/reports");
           }
        } catch (error) {
          let errorMessage = "An unexpected error occurred. Please try again.";
  
          if (error.response && error.response.data) {
            errorMessage = error.response.data.responsemessage || errorMessage;
          }

          console.error("Unexpected error:", error);
          toast.current.show({
            severity: "error",
            summary: "Login Failed",
            detail: errorMessage,
          });
        } finally {
          setLoading(false);
      }
      }
    });

  return (

    <div className="loginContainer grid">
                 {loading && (
                <div className="backdrop">
                    <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
                </div>
            )}
     <Toast ref={toast} position="top-right" />
      <div className="col-7"
        style={{ display: "flex", justifyContent: "center" }}>
              <img
                src="/PlayAble-bnr.png"
                alt="login page image"
                style={{width:"95%"}}
              />
      </div>


      <div className="col-5 flex justify-content-center align-items-center">
        <div className="login-right">

          <div className="loginAreaContainer">
            <h2 className="flex justify-content-center m-0" style={{color:"white"}}>Sign In</h2>
            <p className="flex justify-content-center mb-5 mt-1" style={{color:"#fff"}}>
              Welcome! Please enter your details.
            </p>

            <form onSubmit={formik.handleSubmit}>
              <div >
                <label htmlFor="username" style={{color:"white"}}>User ID</label>
                <InputText
                  id="userid"
                  name="userid"
                  style={{marginTop:"5px", color:"#fff"}}
                  placeholder="Enter User ID"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.userid}
                  className={
                    formik.errors.userid && formik.touched.userid
                      ? "p-invalid p-inputtext input-style custom-placeholder"
                      : "p-inputtext input-style custom-placeholder"
                  }
                />
                {formik.errors.userid && formik.touched.userid && (
                  <span className="p-error" style={{color:"#2C2F8C"}}>{formik.errors.userid}</span>
                )}
              </div>

              <div className="mt-3">
                <label htmlFor="password" style={{color:"white"}}>Password</label>
                <Password
                  id="password"
                  name="password"
                  style={{marginTop:"5px", width:"100%"}}
                  toggleMask
                  feedback={false}
                  placeholder="Enter password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                  className={
                    formik.errors.password && formik.touched.password
                      ? "p-invalid p-password input-style custom-placeholder"
                      : "p-password input-style custom-placeholder"
                  }
                />
                {formik.errors.password && formik.touched.password && (
                    <span className="p-error" style={{color:"#2C2F8C"}}>{formik.errors.password}</span>
                  )}
              </div>
              <Button
                label="Login"
                className="button-style"
                type="submit"
              />
            </form>

          </div>
        </div>
        <p style={{
                position: "fixed",
                bottom: "0px",
                fontSize: "12px",
                color: "#9D9D9D",
              }}>
                Powered by KavinTech Corporation, Bangalore
            </p>
      </div>
    </div>
  );
};

export default Login;
